import { novaClient } from "@/lib/trpc";

export function useParseDemoConfigFromJobUrl() {
  return novaClient.internal.admin.demoConfigs.autofill.useMutation();
}
